export function renderTextFieldJsxFieldControllerTemplate({
  name,
  fieldContainerClass,
  formLabelWithDescriptionLine,
  inputType,
  escapeAttribute,
  inputClass,
  errorMessageLine
}: {
  name: string
  fieldContainerClass: string
  formLabelWithDescriptionLine: string
  inputType: string
  escapeAttribute: string
  inputClass: string
  errorMessageLine: string
}): string {
  return `        <Controller
          control={form.control}
          name="${name}"
          render={({ field }) => (
            <div className="${fieldContainerClass}">
              ${formLabelWithDescriptionLine}
              <input
                id="${name}"
                type="${inputType}"
                placeholder="${escapeAttribute}"
                value={field.value ?? ''}
                onChange={field.onChange}
                onBlur={field.onBlur}
                name={field.name}
                ref={field.ref}
                className="${inputClass}"
              />
${errorMessageLine}
            </div>
          )}
        />`
}
